var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2298 4H7.39404C6.56562 4 5.89404 4.67157 5.89404 5.5V18.5C5.89404 19.3284 6.56561 20 7.39404 20H17.394C18.2225 20 18.894 19.3284 18.894 18.5V8.66421C18.894 8.26639 18.736 7.88486 18.4547 7.60355L15.2905 4.43934C15.0092 4.15803 14.6277 4 14.2298 4Z",
    stroke: "#092682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.394 12.5L11.7274 14L14.394 11",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.394043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.b90793374669902bf4966abafbae757b.svg";
export { ForwardRef as ReactComponent };